import { isNotDefined } from '@sgme/fp';
import type { AppState } from 'state/state.model';

import {
  getUserPreferencesAvailableCurrencies,
  getUserPreferencesAvailableProductSubtypes,
  getUserPreferencesAvailableProductTypes,
  getUserPreferencesAvailableWrappers,
  getUserPreferencesCurrency,
  getUserPreferencesProductSubtype,
  getUserPreferencesProductType,
  getUserPreferencesWrapper,
} from './userPreferences.selectors';

export type ValidationStatus = 'valid' | 'invalid' | 'hidden';

function Validate<T>(selected: T | null | undefined, available: T[]): ValidationStatus {
  if (isNotDefined(selected)) {
    return 'hidden';
  }
  return available.some(x => x === selected) ? 'valid' : 'invalid';
}

export function getUserPreferencesProductTypeValidity(state: AppState): ValidationStatus {
  const selected = getUserPreferencesProductType(state);
  const available = getUserPreferencesAvailableProductTypes(state);
  return available.some(x => x === selected) ? 'valid' : 'invalid';
}

export function getUserPreferencesProductSubTypeValidity(state: AppState): ValidationStatus {
  if (getUserPreferencesProductTypeValidity(state) !== 'valid') {
    return 'hidden';
  }
  const selected = getUserPreferencesProductSubtype(state);
  const available = getUserPreferencesAvailableProductSubtypes(state);
  return Validate(selected, available);
}

export function getUserPreferencesWrapperValidity(state: AppState): ValidationStatus {
  if (getUserPreferencesProductSubTypeValidity(state) !== 'valid') {
    return 'hidden';
  }
  const selected = getUserPreferencesWrapper(state);
  const available = getUserPreferencesAvailableWrappers(state);
  return Validate(selected, available);
}

export function getUserPreferencesCurrencyValidity(state: AppState): ValidationStatus {
  const selected = getUserPreferencesCurrency(state);
  const available = getUserPreferencesAvailableCurrencies(state);

  if (isNotDefined(selected)) {
    return 'valid';
  }
  return available.some(x => x === selected) ? 'valid' : 'invalid';
}

export function getUserPreferencesProducTabErrorCount(state: AppState): number {
  const validations: ValidationStatus[] = [
    getUserPreferencesProductTypeValidity(state),
    getUserPreferencesProductSubTypeValidity(state),
    getUserPreferencesWrapperValidity(state),
    getUserPreferencesCurrencyValidity(state),
  ];
  return validations.filter(x => x === 'invalid').length;
}
